import { render, staticRenderFns } from "./CollectionImageUploader.vue?vue&type=template&id=4493f455&scoped=true&"
import script from "./CollectionImageUploader.vue?vue&type=script&lang=js&"
export * from "./CollectionImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./CollectionImageUploader.vue?vue&type=style&index=0&id=4493f455&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493f455",
  null
  
)

export default component.exports